import { create } from 'zustand';
import type { WeatherMetadata, WeatherRequest, WeatherTimeMode } from './imagery';

interface WeatherOverlayState {
  mode: WeatherTimeMode;
  refreshId: number;
  request: WeatherRequest | null;
  metadata: WeatherMetadata | null;
  phase: 'off' | 'loading' | 'available' | 'unavailable' | 'error';
  message: string | null;
  checkedAt: number | null;
  tileError: string | null;
  setMode: (mode: WeatherTimeMode) => void;
  refresh: () => void;
}
export const useWeatherOverlay = create<WeatherOverlayState>()((set) => ({
  mode: 'latest',
  refreshId: 0,
  request: null,
  metadata: null,
  phase: 'off',
  message: null,
  checkedAt: null,
  tileError: null,
  setMode: (mode) => set({ mode }),
  refresh: () => set((s) => ({ refreshId: s.refreshId + 1 })),
}));
